import i18next from 'i18next';
import { Timezones } from 'infrastructure/enums';

export interface ITimezoneItem {
  id: Timezones | null;
  name: string;
}

const mainlandTimezones = [
  Timezones['America/Chicago'],
  Timezones['America/New_York'],
  Timezones['America/Denver'],
  Timezones['America/Los_Angeles'],
];

export const mainlandTimezonesMapping: Partial<Record<Timezones, Timezones[]>> =
  {
    [Timezones['America/Chicago']]: [
      Timezones['America/Belize'],
      Timezones['America/Chicago'],
      Timezones['America/Costa_Rica'],
      Timezones['America/El_Salvador'],
      Timezones['America/Guatemala'],
      Timezones['America/Managua'],
      Timezones['America/Mexico_City'],
      Timezones['America/Regina'],
      Timezones['America/Tegucigalpa'],
      Timezones['America/Winnipeg'],
      Timezones['Pacific/Galapagos'],
    ],
    [Timezones['America/New_York']]: [
      Timezones['America/Bogota'],
      Timezones['America/Cancun'],
      Timezones['America/Cayman'],
      Timezones['America/Guayaquil'],
      Timezones['America/Havana'],
      Timezones['America/Iqaluit'],
      Timezones['America/Jamaica'],
      Timezones['America/Lima'],
      Timezones['America/Nassau'],
      Timezones['America/New_York'],
      Timezones['America/Panama'],
      Timezones['America/Port'],
      Timezones['America/Rio_Branco'],
      Timezones['America/Toronto'],
      Timezones['Pacific/Easter'],
    ],
    [Timezones['America/Denver']]: [
      Timezones['America/Dawson_Creek'],
      Timezones['America/Denver'],
      Timezones['America/Edmonton'],
      Timezones['America/Hermosillo'],
      Timezones['America/Mazatlan'],
      Timezones['America/Phoenix'],
      Timezones['America/Yellowknife'],
    ],
    [Timezones['America/Los_Angeles']]: [
      Timezones['America/Los_Angeles'],
      Timezones['America/Tijuana'],
      Timezones['America/Vancouver'],
      Timezones['America/Whitehorse'],
      Timezones['Pacific/Pitcairn'],
    ],
  };

export const timezonesDataSource = (
  mainlandTimezonesOnly = false,
  withAll = false,
): ITimezoneItem[] => {
  let timezones: ITimezoneItem[] = (
    Object.keys(Timezones) as Array<keyof typeof Timezones>
  ).map((timezone) => ({
    id: Timezones[timezone],
    name: i18next.t(`timezones.${timezone}`),
  }));

  if (mainlandTimezonesOnly) {
    timezones = timezones.filter((timezone) => {
      if (!timezone?.id) return false;
      return mainlandTimezones.includes(timezone.id);
    });
  }

  if (withAll) {
    timezones.unshift({
      id: null,
      name: i18next.t('timezones.all'),
    });
  }

  return timezones;
};
